import React from 'react';
import { cn } from '@/lib/utils';

export interface CardProps {
  title?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  variant?: 'default' | 'glass';
}

const Card: React.FC<CardProps> = ({
  title,
  action,
  children,
  footer,
  className,
  variant = 'default',
}) => {
  return (
    <div
      className={cn(
        'overflow-hidden rounded-lg border border-border bg-card text-card-foreground shadow-sm transition-colors',
        variant === 'glass' && 'bg-card/60 shadow-lg backdrop-blur-md',
        className
      )}
    >
      {(title || action) && (
        <div className="flex items-center justify-between border-b border-border p-4">
          {title && (
            <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          )}
          {action && <div className="flex items-center gap-2">{action}</div>}
        </div>
      )}
      <div className="p-4">{children}</div>
      {footer && (
        <div className="border-t border-border bg-muted/20 p-4">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;
